import React from "react";
import Particles from "react-tsparticles";

export default function ParticleBackground() {
  const config = {
    fullScreen: { enable: true, zIndex: -1 },
    particles: {
      number: { value: 100 },
      color: { value: "#00e5fe" },
      shape: { type: "circle" },
      opacity: { value: 0.6 },
      size: { value: { min: 2, max: 5 } },
      move: { enable: true, speed: 1.8, random: true },
      links: {
        enable: true,
        distance: 150,
        color: "#00e5fe",
        opacity: 0.2,
        width: 1,
      },
    },
    interactivity: {
      events: { onHover: { enable: true, mode: "repulse" } },
      modes: { repulse: { distance: 100, duration: 0.4 } },
    },
    detectRetina: true,
  };

  return <Particles id="tsparticles" options={config} />;
}
